<template>
  <div :class="{ 'ui-workspace--viewport': isSchedule }">
    <app-page-header design="new" title="Leaves" compact />
    <app-tabs design="new" refined weight="medium" :tabs="tabsToShow" />
    <transition name="fade" mode="out-in">
      <router-view :key="$route.name" class="ui-workspace__content" />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'EmployeesLeavesLayout',
  components: { AppTabs },
  computed: {
    isSchedule() {
      return this.$route.name === 'employees-leaves-schedule'
    },
    tabsToShow() {
      const roles = ['general_manager', 'hr_manager', 'hr_supervisor']
      const tabs = [
        { name: 'employees-leaves', label: 'Requests', roles },
        { name: 'employees-leaves-schedule', label: 'Schedule', roles },
        { name: 'employees-leaves-list', label: 'Leaves', roles },
      ]
      return tabs.filter(tab => tab.roles.some(role => this.$store.state.userGroups.some(userRole => userRole.code === role)))
    },
  },
}
</script>
